import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { Panel } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import CustomPageTitle from 'components/CustomPageTitle/CustomPageTitle';
import { FallbackComponent } from 'components/ErrorBoundary/FallbackComponent';
import Footer from 'components/Footer/Footer';
import { ErrorBoundary } from 'react-error-boundary';
import { useParams } from 'react-router-dom';
import { BREAKPOINT } from 'utils/responsivenessUtils';

function genericPageBuilder(title: string, Component?: React.ComponentType, adjustHeight = true) {
  function GenericContainer() {
    const { t } = useTranslation();
    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down(BREAKPOINT));

    const params = useParams();
    return (
      <>
        <CustomPageTitle title={t(title, params)} />
        <div
          style={{
            display: 'flex',
            padding: 0,
            margin: 0,
            height: mobileView ? 'calc(100% - 50px)' : 'calc(100% - 93px)',
          }}
        >
          <Panel
            spacing={0}
            bodyHeight='100%'
            style={{
              height: '100%',
              overflowY: adjustHeight ? 'auto' : 'hidden',
              overflowX: 'hidden',
            }}
          >
            <ErrorBoundary FallbackComponent={FallbackComponent}>{Component ? <Component /> : null}</ErrorBoundary>
          </Panel>
        </div>
        {!mobileView && <Footer />}
      </>
    );
  }
  return GenericContainer;
}

export default genericPageBuilder;
